import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { competitionBunja } from '../../bunja';
import { EndedPrize } from './ended';
import { FixedPrize } from './fixed';
import { MilestonePrize } from './milestone';

export const PrizeSection = () => {
  const { competitionAtom, registrationMetaAtom } = useBunja(competitionBunja);
  const competition = useAtomValue(competitionAtom);
  const registrationMeta = useAtomValue(registrationMetaAtom);

  if (!competition) return null;

  return registrationMeta ? (
    <EndedPrize />
  ) : competition.milestone && competition.milestone.length > 0 ? (
    <MilestonePrize />
  ) : (
    <FixedPrize />
  );
};
